// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__33MAx","label":"Section_label__I-Ruv","contentWrap":"Section_contentWrap__2RE4m","footer":"Section_footer__3RTZ1","footerInner":"Section_footerInner__2lbhs"};